import { FilesUploader } from "components";
import { MediaDirectoryKeys } from "constants/enums";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, MediaFilePicker } from "ui";

import { ProductFormValues } from "../../ProductDetailsForm.types";
import { VariantBlockPartProps } from "./VariantBlock.types";

export const VariantGifBlock = ({ variantIndex }: VariantBlockPartProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<ProductFormValues>();

  return (
    <div>
      <Controller
        control={control}
        name={`variants.${variantIndex}.preview`}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormField
            label={t("Animated preview")}
            errorMessage={error?.message}
          >
            <FilesUploader
              onSuccessUploading={onChange}
              uploadDirectoryKey={MediaDirectoryKeys.ProductVariant}
            >
              {(uploaderProps) => (
                <MediaFilePicker
                  {...uploaderProps}
                  value={value}
                  acceptImageFormats={[".gif"]}
                  customMaxFileSizeInMB={5}
                  label={"176:248"}
                  onDeleteMediaFile={() => onChange(null)}
                />
              )}
            </FilesUploader>
          </FormField>
        )}
      />
    </div>
  );
};
